import { useAuth } from "@/contexts/AuthContext"
import { Profile } from "./profile/Profile";
import { Alumni } from "iasma-datatypes";

export function ViewPersonal({backpath}: {backpath?: string}) {
  const { session } = useAuth()

  function onUpdateProfile(update: Alumni | undefined) {
    // update session when save profile
    if (session?.User?.Alumni) {
      session.User.Alumni = {
        ...session.User.Alumni,
        ...update
      }
    }
  }

  if (session?.User?.Alumni)
    return <Profile profile={session?.User?.Alumni} onUpdate={onUpdateProfile} editable={true} backpath={backpath} />
  else
    return <div>Alumni is NULL</div>
}

